import React from 'react';

import useRecordGroupDropdown from './UseRecordGroupDropdown';

import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const RecordGroupDropdown = ({ label, name, value, error, message, onChange, makeGetCall = true }) => {
  const { recordGroupState } = useRecordGroupDropdown(makeGetCall);

  return recordGroupState.message
    ? <span className={global.LoadingMsg}>{recordGroupState.message}</span>
    : (
      <Dropdown
        error={error}
        label={label}
        message={message}
        options={recordGroupState.options}
        name={name}
        value={value}
        onChange={onChange}
        isLoading={recordGroupState.areOptionsLoaded !== true}
      />
    );
};

export default RecordGroupDropdown;